import type { CustomerResponseDto } from "Infrastructure/Api/Api";
import { getFormValuesDiff } from "Infrastructure/Utilities/Forms/Helpers/getFormValuesDiff";
import { useHandleServerError } from "Infrastructure/Utilities/Forms/Hooks/useHandleServerError";
import { useUpdateCustomer } from "Order/Api/Mutation/updateCustomerMutation";
import {
	type CustomerEditFormModel,
	getCustomerEditFormSchema,
} from "Order/Components/Form/Schema/customerEditSchema";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

export const useCustomerEditForm = (
	customer: CustomerResponseDto,
	orderId: number,
) => {
	const form = useForm<CustomerEditFormModel>({
		resolver: zodResolver(getCustomerEditFormSchema()),
		defaultValues: customer,
	});

	const {
		formState: { dirtyFields },
	} = form;

	const { mutate: updateCustomer, isPending } = useUpdateCustomer(
		customer.id,
		orderId,
	);
	const { handleServerError } = useHandleServerError(form);

	useEffect(() => {
		form.reset(customer);
	}, [customer]);

	const handleSubmitUpdate = () => {
		handleServerError((data) => {
			const changedValues = getFormValuesDiff(dirtyFields, data);

			if (Object.keys(changedValues).length === 0) return;
			return updateCustomer(changedValues);
		});
	};

	return {
		form,
		isPending,
		handleSubmitUpdate,
	};
};
